import { render } from "./RegisterUser.vue?vue&type=template&id=08d6cf5c"
import script from "./RegisterUser.vue?vue&type=script&lang=js"
export * from "./RegisterUser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__